/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/waterfull/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(26);
	module.exports = __webpack_require__(32);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Structure2 = __webpack_require__(3);
	
	var _Structure3 = _interopRequireDefault(_Structure2);
	
	var _Utils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Building = function (_Structure) {
		_inherits(Building, _Structure);
	
		function Building(image) {
			_classCallCheck(this, Building);
	
			var _this = _possibleConstructorReturn(this, (Building.__proto__ || Object.getPrototypeOf(Building)).call(this));
	
			_this.pipes = [];
	
			if (Array.isArray(image)) {
				_this.sprite = (0, _Utils.animatedSprite)(image);
				_this.waterLevelImages = true;
				_this.waterLevels = Array.apply(null, Array(Building.WATER_IMAGE_SMOOTHING_LEVEL)).map(Number.prototype.valueOf, 0);
				_this.waterLevelsPointer = 0;
			} else {
				_this.sprite = new PIXI.Sprite.fromImage(image);
				_this.waterLevelImages = false;
			}
			_this.sprite.anchor.x = 0.5;
			_this.sprite.anchor.y = 0.5;
			_this.addChildAt(_this.sprite, 0);
			return _this;
		}
	
		_createClass(Building, [{
			key: 'addWater',
			value: function addWater(water) {
				_get(Building.prototype.__proto__ || Object.getPrototypeOf(Building.prototype), 'addWater', this).call(this, water);
				this.updateImage();
			}
		}, {
			key: 'lowerWater',
			value: function lowerWater(water) {
				_get(Building.prototype.__proto__ || Object.getPrototypeOf(Building.prototype), 'lowerWater', this).call(this, water);
				this.updateImage();
			}
		}, {
			key: 'destructor',
			value: function destructor() {
				var _this2 = this;
	
				_get(Building.prototype.__proto__ || Object.getPrototypeOf(Building.prototype), 'destructor', this).call(this);
				this.pipes.forEach(function (pipe) {
					var ob = pipe.getOther(_this2);
					ob[0].pipes.splice(ob[0].pipes.indexOf(pipe), 1);
					pipe.parent.removeChild(pipe);
				});
			}
		}, {
			key: 'updateImage',
			value: function updateImage() {
				if (this.waterLevelImages && this.isActive()) {
	
					this.waterLevels[this.waterLevelsPointer] = this.water;
					this.waterLevelsPointer += 1;
					if (this.waterLevelsPointer >= this.waterLevels.length) {
						this.waterLevelsPointer = 0;
					}
	
					var water = (0, _Utils.avg)(this.waterLevels);
	
					this.sprite.gotoAndStop(Math.round(water / this.getCapacity() * (this.sprite.totalFrames - 1)));
				}
			}
		}]);
	
		return Building;
	}(_Structure3.default);
	
	exports.default = Building;
	
	
	Building.WATER_IMAGE_SMOOTHING_LEVEL = 23;

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shuffle = shuffle;
	exports.animatedSprite = animatedSprite;
	exports.distance = distance;
	exports.sum = sum;
	exports.avg = avg;
	function shuffle(a, amount) {
	  var j, x, i;
	  if (amount === undefined) {
	    amount = a.length;
	  }
	  for (i = amount; i; i--) {
	    j = Math.floor(Math.random() * i);
	    x = a[i - 1];
	    a[i - 1] = a[j];
	    a[j] = x;
	  }
	}
	
	function animatedSprite(images) {
	  var textureArray = [];
	
	  for (var i = 0; i < images.length; i++) {
	    var texture = PIXI.Texture.fromImage(images[i]);
	    textureArray.push(texture);
	  }
	
	  return new PIXI.extras.AnimatedSprite(textureArray);
	}
	
	function distance(s1, s2) {
	  var dx = s1.x - s2.x;
	  var dy = s1.y - s2.y;
	  return Math.sqrt(dx * dx + dy * dy);
	}
	
	function sum(arr) {
	  return arr.reduce(function (a, b) {
	    return a + b;
	  });
	}
	
	function avg(arr) {
	  return sum(arr) / arr.length;
	}

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Utils = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Structure = function (_PIXI$Container) {
		_inherits(Structure, _PIXI$Container);
	
		function Structure() {
			_classCallCheck(this, Structure);
	
			var _this = _possibleConstructorReturn(this, (Structure.__proto__ || Object.getPrototypeOf(Structure)).call(this));
	
			_this.level = 0;
			_this.targetLevel = 1;
			_this.water = 0;
	
			_this.upgradeClock = (0, _Utils.animatedSprite)([__webpack_require__(21), __webpack_require__(22), __webpack_require__(23), __webpack_require__(24), __webpack_require__(25)]);
			_this.upgradeClock.anchor.x = 0.5;
			_this.upgradeClock.anchor.y = 0.5;
			_this.addChild(_this.upgradeClock);
			return _this;
		}
	
		_createClass(Structure, [{
			key: 'getWater',
			value: function getWater() {
				return this.water;
			}
		}, {
			key: 'getCapacity',
			value: function getCapacity() {
				return 1;
			}
		}, {
			key: 'addWater',
			value: function addWater(water) {
				if (this.isActive()) {
					this.water = Math.min(this.getCapacity(), this.water + water);
				} else {
					this.water += water;
					this.updateUpgradeClock();
				}
			}
		}, {
			key: 'lowerWater',
			value: function lowerWater(water) {
				this.water = Math.max(0, this.water - water);
			}
		}, {
			key: 'isActive',
			value: function isActive() {
				return this.level === this.targetLevel;
			}
		}, {
			key: 'getRequiredWater',
			value: function getRequiredWater() {
				return 100 * Math.abs(this.level - this.targetLevel);
			}
		}, {
			key: 'upgrade',
			value: function upgrade() {
				if (Structure.LEVELING_ENABLED || this.targetLevel < 1) {
					this.targetLevel += 1;
					this.updateUpgradeClock();
				}
			}
		}, {
			key: 'downgrade',
			value: function downgrade() {
				if (this.targetLevel > 0) {
					this.targetLevel -= 1;
					this.updateUpgradeClock();
				}
			}
		}, {
			key: 'destructor',
			value: function destructor() {
				this.parent.removeChild(this);
				//TODO spawn water particles
			}
		}, {
			key: 'tick',
			value: function tick() {
				if (this.getWater() >= this.getRequiredWater()) {
					this.water -= this.getRequiredWater();
					this.level = this.targetLevel;
					this.updateUpgradeClock();
					if (this.level <= 0) {
						this.destructor();
					}
				}
			}
		}, {
			key: 'updateUpgradeClock',
			value: function updateUpgradeClock() {
				if (!this.isActive()) {
					this.upgradeClock.visible = true;
					this.upgradeClock.gotoAndStop(Math.round(this.water / this.getRequiredWater() * (this.upgradeClock.totalFrames - 1)));
				} else {
					this.upgradeClock.visible = false;
				}
			}
		}]);
	
		return Structure;
	}(PIXI.Container);
	
	exports.default = Structure;
	
	
	Structure.LEVELING_ENABLED = false;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/background.448e2e8e.png";

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KeyListener = function () {
		function KeyListener(keyCode, press, release) {
			var _this = this;
	
			_classCallCheck(this, KeyListener);
	
			this.code = keyCode;
			this.isDown = false;
			this.isUp = true;
			this.press = press;
			this.release = release;
	
			this.downHandler = function (event) {
				if (event.keyCode === _this.code) {
					if (_this.isUp && _this.press) _this.press();
					_this.isDown = true;
					_this.isUp = false;
					event.preventDefault();
				}
			};
	
			this.upHandler = function (event) {
				if (event.keyCode === _this.code) {
					if (_this.isDown && _this.release) _this.release();
					_this.isDown = false;
					_this.isUp = true;
					event.preventDefault();
				}
			};
	
			window.addEventListener("keydown", this.downHandler, false);
			window.addEventListener("keyup", this.upHandler, false);
		}
	
		_createClass(KeyListener, [{
			key: "close",
			value: function close() {
				window.removeEventListener("keydown", this.downHandler);
				window.removeEventListener("keyup", this.upHandler);
			}
		}]);
	
		return KeyListener;
	}();
	
	exports.default = KeyListener;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Building2 = __webpack_require__(1);
	
	var _Building3 = _interopRequireDefault(_Building2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var In = function (_Building) {
		_inherits(In, _Building);
	
		function In() {
			_classCallCheck(this, In);
	
			var _this = _possibleConstructorReturn(this, (In.__proto__ || Object.getPrototypeOf(In)).call(this, __webpack_require__(12)));
	
			_this.sprite.scale.x = 0.2;
			_this.sprite.scale.y = 0.2;
			return _this;
		}
	
		_createClass(In, [{
			key: "getCapacity",
			value: function getCapacity() {
				return 0;
			}
		}, {
			key: "tick",
			value: function tick() {
				_get(In.prototype.__proto__ || Object.getPrototypeOf(In.prototype), "tick", this).call(this);
				if (this.isActive()) {
					this.water = this.level;
				}
			}
		}]);
	
		return In;
	}(_Building3.default);
	
	exports.default = In;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(46);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/in_0.73130908.png";

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/out_0.254d60d1.png";

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/out_1.d9d98d9c.png";

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/out_2.4954e652.png";

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/point_0.a21553ac.png";

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/reservoir_0.51fc23b2.png";

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/reservoir_1.94a19a26.png";

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/reservoir_2.c4130497.png";

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/reservoir_3.ad98e279.png";

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAYAAABCfffNAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QYLFgMMc73QDAAAApJJREFUSMet1s2Ll1UUB/DPfZQmgzQXvjQ2zvSCDaUuehFx8AUHFFIJXBTSolXgwqBVf4JQlCDiIjfuXIgIEqRIky8l4cYaGzeOoZiYWZiWotM4v9vm/OL285kR/f0OXJ7nPvc+53vvOd97vjflnNVZSilhDt7EIJbhBTyLW7iAYXyH7zGac56odZZzfqDhKbyDo/gdE8g1rYHb+AEfo6fWXw1AL3biRuHsL1zGKRyL5+XYUSPm/IOvsQrVpCB4EV/ifvx4EwfwNl7Fc3gX/dF/CztwsVjQKLaUQCXAAuwrQjOM9zCzmPM0Psei4tv0WP1hjBdAA/8DiRzsLnZwBitqQvlEOJxdM9aDXbgXPr7FyyXIGlyLwfNYXZfAhzXMjfA2SfFJLMwM7CkS/EFr4h4RaHGwLeNnvAErgykZR+pC8RhAHwbbxrG9wto4YA0czzn/qX07jitBinUVBqJzLXjeCbuEc/G+uEJ3dK5E64TdLkC6pmNedH7FopTSBgzlnC89queU0kxsjFxMa36vIkydtvE41P/ZmWDWacxvl1nBrmlR/zJyhT8C7Pko5Z2wWVga72NVHP9xzA7t6IT14aV4H6nwFX4JGm9OKc1tx3tKqcKmYO0YDjbLyhcRv7/xfpv5WBL0zaGerzcHVuNqDIxg1WMC9OFQVI8JbEdXc7ALn7ZZ6udHoW3q0TH0topWd4toncVWdLeI1mctovVkKOSRyEHGT1g2mfz2YH+xo7s4gW14LdRzY8h0f8js3qgWuQDYXCu/BdDCOEjXix/Hoq6dwjcBfAF3ijl3YzcDSFPeVgo5Xh/h+22KK1GOYngSH2Fenb802eUuOP9MrGwQy/FKnOZG3FB+xFDccK7mnBt1fv4FDwTFA2ZuHAAAAAAASUVORK5CYII="

/***/ },
/* 22 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QYLFgQkCUnuMQAAAs5JREFUSMet1k2IllUUB/DffWd01FS0cUJ3OWgfWolaSBQFxYQFgki7PnZuAl1UIIbSzl0SQQTRpohaBIEQlKFmFqTZTCFiEZQgKRg5o6KNOM5725xHLu88jzPNeOHA+977nPO/53/u+Ug5Z00rpTQHa7ABj+E+rMA8/IXT+BFHQ87mJoM55wmCFtbjHfyJUeQGuYERHMZLWFBrswZkbiicQjuMjWM4QI/gII7jHK4WoJfwAR5AKu2m0tOU0hK8jq24MwB+w+c4hPO4iHvRh2voxbMYwOIAPIEdOef9E6hDD3aHcnW7d7EKXcV3vfgyQAfxNp4JFo4XLPyABydQhxfxT3x0Hq9gfg21ffEAKrraOIO3sBGfYizOvsbym0BYiaE4vII3MLvhofThWM2jGMeHWIv9sTeG16rwJOyI15PxMRbVgUwClIP2N8OzM7E3iFUt3BUHXZEb7+WcL5re6sG2yLN9sXc/Blp4KAIunu6Qma1ePI9vcCHSZXMLD2NRBHUw5zxq5uvRAPmp+t/C05gViff7FIykqByTebUYv1aUduPJUL6C6ymllyNWh3PO7RojYzgZOuMNQO2I+U397mnQcgmvTkH3Kh4vgb7FU5gfufPRrbTDy5FJ+U2pJ8qYqkofDDruwD1u31qC1fH7WivKyXDVGlJKc28T0CPFxY+28HORO09g3UwRUkoL8QIWRKw++98laCoSLePvsHcM/dXB3fiuKKq7MW+aIOvwfdgaxdbONrE52kPGZexqaBPLYn5INWfrC5CML7C0E2h2FMQLBdj7ccOy8W3AnmovqF8WXXmwADmA1bUzQ1Tf7UUDbEcZ2YtN6I9q/ByWRp3cFrn4bxNI03AyJ7rtUNEp2+HhqajKh6JVn8P1AmAYn3SC1AIVdKzETvzScdtOaQcD+7AFC+tspkkGyK5IuoGYdPpDuuP2f8TE81V4OdI0QP4HO3JMIfe9tXgAAAAASUVORK5CYII="

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QYLFgYe/XNVAQAAAtZJREFUSMe11kuIlmUUB/Df+zqNo5g06nRBIrpMSRq1EOyyCiuUiEKinbUICwJr0SKCitpEm6CEWrSMaBEhBEZhNop0my4QCiZihaGRlqNJk1Pm97T5v8Pb+H0MM2MHno/veZ/D+T/nPP9zqUopeklVVQO4EWtwG1bgGizEYfyIL/FF1pHSy2Ap5ZyFeViNLfgBp1F6rH9wAjvxMJZ1tdkFZAEewQF0YuwsxgK6Gx/jK/yM8RboON7Bqql2q7anVVUN4UlswpIA7MdWjOAoTuI6DGECS7Eed2IwgKN4HtsnQ9nyZAAv4e8o/47XcD3mtfSW4oOAfoNXcBc2xssmCt/ipnNChw04FqXDeBSLuoR2KARowtXBT3gZ6/A2zuRsGy6dBMIwvs7hBJ5qe9EFaLQHKd7CzdjesvUEavl5OooljznUDWQaoIY0W3B/iFKwB6tqLMe9ofQRvFpK+dXspMZDIcXWfFuBB+r8uTIfd+SB5yKLQ44RHMcFWFcnMS9K6EZLKRPmLquTBnuzv6EB6gutf3N+5BJchn3ZD/Th1sT2FMarqnow9N5VSunMEKCTUjSG+Sldk493YVP2Er7/RercoGAR+kspb5ZSRmbhTWNvLe7OpZe0Dz5LJi/A5efJgWNJleHsJ+pUhJMhxJr0oLnK5+lZ12a/t07mNuy4IyVkLnIc7+E+XJwy9G4dNz9M+ViOzVVVDc4SpJN6V6XaiBPbmvp1BT4KKf7As1g4w1p3JiD34JN8O41NU9vEevwShVN4ZgZt4hBeCNt2t87+2yZiYD42J8YN2BupHP0tvcG8waGE/MX0ssfS+BqQHVjZdWYI2OMtsLM4iNcTkquxDLeEOGvTb3biz14gvYaTgQwne1qdshMP92FXKvOnyZW/WgBj6bArp52CWuPWMJ7Dd1Nu263ZHU04N2BxN5vVNANkfyae20OWq7L6cvvvk/DvJ0lP9Bog/wXYzw+KMkwiXAAAAABJRU5ErkJggg=="

/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QYLFgM7ywB1AwAAAvxJREFUSMet1ktoXVUUBuDv3EYSbVobm2h9TdS2UQuiBjsQB+IDRak6EIoPEBUVUTsQFBRFxIkTEUGciGJH0lEVUQcNrWJB21CxkIi1vrCp1Ffb0Bit9m4n/4WT5N5EEhfswdn7sB7/Wutfqyql6CRVVfXgEqzHlRjEBTgFB/AdduHTnPHSSWEpZdbBEgzhFXyLKZQO5x8cxg7cjWVtdbYx0ouHsA/NKDuOQ9iD7RjGbhzEZM3oUbyOwZl6q3qkVVX14xncg+U4gc+xORCN429ciIFEehpuwnXoi6phbCqljM6CDt0x8mfNu1exdkbEK/EBfk5eXoyROxNlK7ptuHgadGjgAfyWnw7gQfS2gXYg0bUUNvENXsAGfFx7ew+r6oZW44s8HsPjWNKhUAbwWYei2JzoPsndFO5vpafCk/mxiTewop2ReQyVwP4sNtbQ2YFzGzgdN6Skv8ZLpZQjFibdeDSp2Ja7IWxo4HKsq1XLPouT/lThVkxgKW5ppOP7UrYjpZTjFi+XpcdaTg81cFtgO4bv/6OiMs/7GViRaoS+rjQf/IWJqqoGcWoHZSXR93YwMIn3896fBgddM5Qsx/O4IhXYlmvjyFzSCErqhnZFcXfC7Un3L0SW4vYUwZs4u255a0hzGc7C6P9QDAdDwufn+3ADIziCk3BpmnFikYb24EysyfdIA3sxlovr8Ws4aqHyU1C6NTmfxDsN/BKaKDgn5f4W9i/AyBRei65rW9Hg3RZ/XZS5UwLbU7gjo3omnx2NE802PPcyrsHO3E3ivmkTFncFtpJEPpLoPgprtBTuxnMh4daY+AFPB/r6mNiC/mkTtqqqbjyRaHri+dshx1W4CmvTRz9mUdmfxI/kn3vDnS3efKyUMoZZo3wlHsam9FLBl/gw/XYoG1AX/sj7uiR+PU6ed5TXIOzJtN1bg6yZCEejZDh5GA91taD6vdNyMte6tSb7wFc179udE9kftuDmduN/1hbUYYFcjatxI87L6Yr3Y2nw7dg518D8F9j929HTJ1pZAAAAAElFTkSuQmCC"

/***/ },
/* 25 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QYLFgMf9wOR0gAAAvlJREFUSMe11luMnmMQB/Df+/m67SYomw2yadGqkG0izusUtCJhe4ULEQlxSERCUocLaRBxuBFuiAsucCEkItHQEEW6SVUQ0dKlkfTErmDrkC1Kt90+bv6fvP26X6tbnmSSZ+adzMwz78x/piql6HSqqjoa52AAF2A+TsrnjRjDED7AulLKWEdjpZR9CDOwGK/iB0ygdKCJOHwTS9A9pc0pnPTiAYzUjO3EjxjG+6HhyHbW9LbhcfS1263qqauqqhcP4xZ04S98hNexGd34M+qt+3xclfR2YxdW4r5SyvA+qUMPnqlF+D0exCVYhtUYxWuh0ciWReeOBNN63UrM2yt1aOIe/BGlzbgJ9+KLRNky8Eqoxe+KzlJcgw8j340nMKvuaABbay+5If9p+xQ//9dQu/w33I9F2BDZGAZbv+dwPFuL7jHciJ/2U2mdaBy34e44Lqnco+CiWoWtxmVYOw0nLdqAi7G89qoljQiPxSRW4FQsNP1zMi7Ee8lQDxY1cHoa9Gd8hivCT/cchkGsx6bw5zZwWhRGEsECh37mJdhvwx/TrBkex5Hp7o9xOfoO0sE43sLMBN1ytKDh/zklKHFcS9AICsPs9E1vyrtvGg5m4zqcF2dHtJC+ka6GExPF+v/gRVtSxSeEH2tgXa0MB/BuwHS6ZxJvox9zwn/SwKoAZIWrc//yEBxtxKdB9CZ+wapGUGBFlPrTwE8Hgg72/I7ncCbOj2wIa1qgeja+bgPVW2tAW6fvQu3y7QHi61PWJb25uI7eDdyJHVHYgmtTQWvbxsQLeL7GTybVd8XJVzWAfgjNvSZsVVU9eCQv6cqu8GLmS3+WlIUJYgKn5L4Gn+Ms3IzjsQdvYGkp5RsccJTvDhovz0jfkbFScm8m7YOp2BkJ4mU8WkrZ9I/t9nUrzm7Py+amGvdk2G0NzLSac27aohnno3HyZCll279Zt7oS4VO1VO1v3RrBS9n9Zk5lszrAAjkLZ+BKXBpUnpPPowliCO9guJQy3snW33lLrBNpJjoPAAAAAElFTkSuQmCC"

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(45).enable();
	  window.Promise = __webpack_require__(44);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(48);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(43);


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Stages = __webpack_require__(28);
	
	var _Stages2 = _interopRequireDefault(_Stages);
	
	var _TopScore = __webpack_require__(29);
	
	var _TopScore2 = _interopRequireDefault(_TopScore);
	
	var _WorldGenerator = __webpack_require__(31);
	
	var _WorldGenerator2 = _interopRequireDefault(_WorldGenerator);
	
	var _StagePlay = __webpack_require__(33);
	
	var _StagePlay2 = _interopRequireDefault(_StagePlay);
	
	var _StageTopScore = __webpack_require__(34);
	
	var _StageTopScore2 = _interopRequireDefault(_StageTopScore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var App = function () {
		function App(settings) {
			_classCallCheck(this, App);
	
			this.settings = settings;
			this.stages = new _Stages2.default();
			this.topScore = new _TopScore2.default();
			this.worldGenerator = new _WorldGenerator2.default();
		}
	
		_createClass(App, [{
			key: 'start',
			value: function start() {
				var _this = this;
	
				var setup = function setup() {
					_this.renderer = PIXI.autoDetectRenderer(_this.settings.width, _this.settings.height, { antialias: true });
					document.body.appendChild(_this.renderer.view);
	
					_this.stages.addStage("play", new _StagePlay2.default(_this.stages, _this.settings, _this.renderer.plugins.interaction, _this.worldGenerator));
					_this.stages.addStage("topScore", new _StageTopScore2.default(_this.stages, _this.topScore, _this.settings));
					_this.stages.changeStage("play");
	
					_this.gameLoop = function () {
						_this.stages.beforeRender();
						_this.renderer.render(_this.stages.current);
						requestAnimationFrame(_this.gameLoop);
					};
	
					_this.gameLoop();
				};
	
				PIXI.loader.add(__webpack_require__(4)).add(__webpack_require__(8)).add(__webpack_require__(12)).add(__webpack_require__(9)).add(__webpack_require__(13)).add(__webpack_require__(14)).add(__webpack_require__(15)).add(__webpack_require__(10)).add(__webpack_require__(16)).add(__webpack_require__(11)).add(__webpack_require__(17)).add(__webpack_require__(18)).add(__webpack_require__(19)).add(__webpack_require__(20)).add(__webpack_require__(21)).add(__webpack_require__(22)).add(__webpack_require__(23)).add(__webpack_require__(24)).add(__webpack_require__(25)).load(setup);
			}
		}]);
	
		return App;
	}();
	
	exports.default = App;

/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Stages = function () {
		function Stages() {
			_classCallCheck(this, Stages);
	
			this.current = undefined;
			this.list = [];
		}
	
		_createClass(Stages, [{
			key: "addStage",
			value: function addStage(name, stage) {
				this.list[name] = stage;
			}
		}, {
			key: "changeStage",
			value: function changeStage(name) {
				if (!this.list[name]) {
					throw new Error("Illegal stage name.");
				}
				if (this.current !== undefined) {
					this.current.unload();
				}
				this.current = this.list[name];
				this.current.load();
			}
		}, {
			key: "getStage",
			value: function getStage(name) {
				return this.list[name];
			}
		}, {
			key: "beforeRender",
			value: function beforeRender() {
				this.current.tick();
			}
		}]);
	
		return Stages;
	}();
	
	/*
	Stage interface:
	{
		load = function()
		unload = function()
		tick = function()
	}
	*/
	
	
	exports.default = Stages;

/***/ },
/* 29 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TopScore = function () {
		function TopScore() {
			_classCallCheck(this, TopScore);
	
			if (!window.localStorage.topScore) {
				window.localStorage.topScore = JSON.stringify([]);
			}
			this.topScore = JSON.parse(window.localStorage.topScore);
		}
	
		_createClass(TopScore, [{
			key: 'addScore',
			value: function addScore(score) {
				this.topScore.push(score);
				this.topScore.sort(function (a, b) {
					return parseInt(b, 10) - parseInt(a, 10);
				});
				window.localStorage.topScore = JSON.stringify(this.topScore);
	
				if (window.ga) {
					ga('send', 'event', 'Game', 'score', {
						"metric5": score
					});
				}
			}
		}, {
			key: 'getTop',
			value: function getTop(count) {
				return this.topScore.slice(0, count);
			}
		}]);
	
		return TopScore;
	}();
	
	exports.default = TopScore;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Utils = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WaterNetworkSimulator = function () {
	  function WaterNetworkSimulator(world) {
	    _classCallCheck(this, WaterNetworkSimulator);
	
	    this.world = world;
	  }
	
	  _createClass(WaterNetworkSimulator, [{
	    key: 'tick',
	    value: function tick() {
	
	      // Reset pipes
	      this.world.pipes.children.forEach(function (pipe) {
	        pipe.waterSpeed = 0;
	      });
	
	      // Simulate water
	      this.world.buildings.children.forEach(function (building) {
	        building.tick();
	
	        if (building.getWater() === 0) {
	          return;
	        }
	
	        if (building.isActive()) {
	
	          building.pipes.forEach(function (pipe) {
	
	            if (pipe.isActive()) {
	
	              var otherBuilding, pipeDirection;
	
	              var _pipe$getOther = pipe.getOther(building);
	
	              var _pipe$getOther2 = _slicedToArray(_pipe$getOther, 2);
	
	              otherBuilding = _pipe$getOther2[0];
	              pipeDirection = _pipe$getOther2[1];
	
	
	              if (otherBuilding.isActive()) {
	                if (otherBuilding.getWater() < otherBuilding.getCapacity()) {
	                  var ma = Math.min(otherBuilding.getCapacity() - otherBuilding.getWater(), Math.min(building.getWater(), pipe.getCapacity() - Math.abs(pipe.waterSpeed)));
	                  otherBuilding.addWater(ma);
	                  pipe.waterSpeed += pipeDirection * ma;
	                  building.lowerWater(ma);
	                }
	              } else {
	                var _ma = Math.min(otherBuilding.getRequiredWater() - otherBuilding.getWater(), Math.min(building.getWater(), pipe.getCapacity() - Math.abs(pipe.waterSpeed)));
	                otherBuilding.addWater(_ma);
	                pipe.waterSpeed += pipeDirection * _ma;
	                building.lowerWater(_ma);
	              }
	            } else {
	              var _ma2 = Math.min(building.getWater(), pipe.getRequiredWater() - pipe.getWater());
	              pipe.addWater(_ma2);
	              building.lowerWater(_ma2);
	            }
	          });
	
	          (0, _Utils.shuffle)(building.pipes);
	        }
	      });
	
	      //Redraw pipes
	      this.world.pipes.children.forEach(function (pipe) {
	        pipe.tick();
	        pipe.redraw();
	      });
	    }
	  }]);
	
	  return WaterNetworkSimulator;
	}();
	
	exports.default = WaterNetworkSimulator;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _In = __webpack_require__(6);
	
	var _In2 = _interopRequireDefault(_In);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorldGenerator = function () {
	  function WorldGenerator() {
	    _classCallCheck(this, WorldGenerator);
	  }
	
	  _createClass(WorldGenerator, [{
	    key: 'generateWorld',
	    value: function generateWorld(world) {
	      this.spawnIn(world, new PIXI.Point(0, 0));
	    }
	  }, {
	    key: 'spawnIn',
	    value: function spawnIn(world, point) {
	      this.spawnBuilding(world, new _In2.default(), point);
	    }
	  }, {
	    key: 'spawnBuilding',
	    value: function spawnBuilding(world, building, point) {
	      building.x = point.x;
	      building.y = point.y;
	      building.level = 1;
	      building.interactive = true;
	      world.buildings.addChild(building);
	    }
	  }]);
	
	  return WorldGenerator;
	}();
	
	exports.default = WorldGenerator;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _App = __webpack_require__(27);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settings = {
		width: 960,
		height: 640,
		fullpage: true
	};
	
	if (settings.fullpage) {
		settings.width = window.innerWidth;
		settings.height = window.innerHeight;
	}
	
	window.app = new _App2.default(settings);
	window.app.start();
	
	setTimeout(function () {
		console.log("Destroy!");
		document.body.innerHTML = '';
	}, 4 * 60 * 1000);

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BuildCursor = __webpack_require__(36);
	
	var _BuildCursor2 = _interopRequireDefault(_BuildCursor);
	
	var _WaterNetworkSimulator = __webpack_require__(30);
	
	var _WaterNetworkSimulator2 = _interopRequireDefault(_WaterNetworkSimulator);
	
	var _BuildingsBar = __webpack_require__(37);
	
	var _BuildingsBar2 = _interopRequireDefault(_BuildingsBar);
	
	var _EditBuildingGui = __webpack_require__(38);
	
	var _EditBuildingGui2 = _interopRequireDefault(_EditBuildingGui);
	
	var _Board = __webpack_require__(35);
	
	var _Board2 = _interopRequireDefault(_Board);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StagePlay = function (_PIXI$Container) {
		_inherits(StagePlay, _PIXI$Container);
	
		function StagePlay(stages, settings, interactionManager, worldGenerator) {
			_classCallCheck(this, StagePlay);
	
			var _this = _possibleConstructorReturn(this, (StagePlay.__proto__ || Object.getPrototypeOf(StagePlay)).call(this));
	
			_this.stages = stages;
			_this.settings = settings;
			_this.interactionManager = interactionManager;
			_this.worldGenerator = worldGenerator;
	
			_this.time = 0;
			_this.waterDelivered = 0;
			return _this;
		}
	
		_createClass(StagePlay, [{
			key: 'load',
			value: function load() {
	
				this.world = new PIXI.Container();
				this.world.x = this.settings.width / 2;
				this.world.y = this.settings.height / 2;
	
				var board = new _Board2.default();
				this.world.board = board;
				this.world.addChild(board);
	
				var pipes = new PIXI.Container();
				this.world.pipes = pipes;
				this.world.addChild(pipes);
	
				var buildings = new PIXI.Container();
				this.world.buildings = buildings;
				this.world.addChild(buildings);
	
				this.waterNetworkSimulator = new _WaterNetworkSimulator2.default(this.world);
	
				this.editBuildingGui = new _EditBuildingGui2.default(this.world);
	
				this.buildCursor = new _BuildCursor2.default(this.world, this.editBuildingGui, this.interactionManager, this);
	
				this.buildingsBar = new _BuildingsBar2.default(this.buildCursor);
				this.buildingsBar.x = this.settings.width / 2 - 60 * 5 / 2;
				this.buildingsBar.y = this.settings.height - 60;
	
				this.waterDelivered = 0;
	
				this.waterDeliveredText = new PIXI.Text("0", new PIXI.TextStyle({ fontSize: 40, fill: '#000000' }));
				this.waterDeliveredText.x = 16;
				this.waterDeliveredText.y = 16;
	
				this.addChild(this.world);
				this.addChild(this.buildCursor);
				this.addChild(this.editBuildingGui);
				this.addChild(this.buildingsBar);
				this.addChild(this.waterDeliveredText);
	
				this.worldGenerator.generateWorld(this.world);
			}
		}, {
			key: 'tick',
			value: function tick() {
				this.waterNetworkSimulator.tick();
	
				var zoom = StagePlay.MIN_ZOOM_OUT + this.time / StagePlay.ZOOM_OUT_DURATION * (StagePlay.MAX_ZOOM_OUT - StagePlay.MIN_ZOOM_OUT);
				if (zoom <= StagePlay.MAX_ZOOM_OUT) {
					this.world.scale.x = 1 / zoom;
					this.world.scale.y = 1 / zoom;
	
					this.buildCursor.scale.x = 1 / zoom;
					this.buildCursor.scale.y = 1 / zoom;
				}
	
				this.time += 1;
	
				this.waterDeliveredText.text = "" + this.waterDelivered;
			}
		}, {
			key: 'restart',
			value: function restart() {
				this.unload();
				this.load();
			}
		}, {
			key: 'unload',
			value: function unload() {
				this.removeChild(this.world);
				this.removeChild(this.buildCursor);
				this.removeChild(this.editBuildingGui);
				this.removeChild(this.buildingsBar);
				this.removeChild(this.waterDeliveredText);
	
				this.buildingsBar.destructor();
	
				this.waterNetworkSimulator = undefined;
				this.world = undefined;
				this.buildCursor = undefined;
				this.editBuildingGui = undefined;
				this.buildingsBar = undefined;
				this.waterDeliveredText = undefined;
			}
		}]);
	
		return StagePlay;
	}(PIXI.Container);
	
	exports.default = StagePlay;
	
	
	StagePlay.MIN_ZOOM_OUT = 0.6;
	StagePlay.MAX_ZOOM_OUT = 2.0;
	StagePlay.ZOOM_OUT_DURATION = 25000;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _KeyListener = __webpack_require__(5);
	
	var _KeyListener2 = _interopRequireDefault(_KeyListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageTopScore = function (_PIXI$Container) {
		_inherits(StageTopScore, _PIXI$Container);
	
		function StageTopScore(stages, topScore, settings) {
			_classCallCheck(this, StageTopScore);
	
			var _this = _possibleConstructorReturn(this, (StageTopScore.__proto__ || Object.getPrototypeOf(StageTopScore)).call(this));
	
			_this.stages = stages;
			_this.topScore = topScore;
			_this.settings = settings;
	
			_this.myScore = -1;
			return _this;
		}
	
		_createClass(StageTopScore, [{
			key: 'addScore',
			value: function addScore(score) {
				this.topScore.addScore(score);
				this.myScore = this.topScore.getTop(StageTopScore.TOP_COUNT).indexOf(score);
			}
		}, {
			key: 'load',
			value: function load() {
				var _this2 = this;
	
				this.background = new PIXI.Graphics();
				this.background.cacheAsBitmap = true;
				this.background.beginFill(StageTopScore.BACKGROUND_COLOR);
				this.background.drawRect(0, 0, this.settings.width, this.settings.height);
	
				this.scores = new PIXI.Container();
				var i = 0;
				this.topScore.getTop(StageTopScore.TOP_COUNT).forEach(function (score) {
	
					var x = i % 10;
					var y = Math.floor(i / 10);
	
					var color = '#E1303C';
					if (_this2.myScore === i) {
						color = '#9FBC12';
					}
	
					var scoreText = new PIXI.Text(score, new PIXI.TextStyle({ fontSize: 14, fill: color }));
					scoreText.x = (x + 1) * (_this2.settings.width / (10 + 1));
					scoreText.y = (y + 1) * (_this2.settings.height / (5 + 1));
					scoreText.anchor.x = 0.5;
					scoreText.anchor.y = 0.5;
	
					_this2.scores.addChild(scoreText);
					i++;
				});
	
				this.crashedTextGuide = new PIXI.Text("Press space to continue", new PIXI.TextStyle({ fontSize: 14, fill: '#9FBC12' }));
				this.crashedTextGuide.x = this.settings.width / 2;
				this.crashedTextGuide.y = this.settings.height - 16;
				this.crashedTextGuide.anchor.x = 0.5;
				this.crashedTextGuide.anchor.y = 1;
	
				this.gameByText = new PIXI.Text("Game by Ienze (Dominik Gmiterko)", new PIXI.TextStyle({ fontSize: 10, fill: '#9FBC12' }));
				this.gameByText.x = 16;
				this.gameByText.y = this.settings.height - 16;
				this.gameByText.anchor.x = 0.0;
				this.gameByText.anchor.y = 1.0;
				this.gameByText.interactive = true;
				this.gameByText.click = function () {
					var win = window.open("http://ienze.me", '_blank');
					win.focus();
				};
	
				this.gameAtText = new PIXI.Text("play at ienze.me/trainwreck", new PIXI.TextStyle({ fontSize: 10, fill: '#9FBC12' }));
				this.gameAtText.x = this.settings.width - 16;
				this.gameAtText.y = this.settings.height - 16;
				this.gameAtText.anchor.x = 1.0;
				this.gameAtText.anchor.y = 1.0;
	
				this.addChild(this.background);
				this.addChild(this.scores);
				this.addChild(this.crashedTextGuide);
				this.addChild(this.gameByText);
				this.addChild(this.gameAtText);
	
				this.keySpace = new _KeyListener2.default(32);
			}
		}, {
			key: 'tick',
			value: function tick() {
				if (this.keySpace.isDown) {
					this.stages.changeStage("play");
				}
			}
		}, {
			key: 'unload',
			value: function unload() {
				this.removeChild(this.background);
				this.removeChild(this.scores);
				this.removeChild(this.crashedTextGuide);
				this.removeChild(this.gameByText);
				this.removeChild(this.gameAtText);
	
				this.keySpace.close();
	
				this.keySpace = undefined;
	
				this.background = undefined;
				this.scores = undefined;
				this.crashedTextGuide = undefined;
				this.gameByText = undefined;
				this.gameAtText = undefined;
			}
		}]);
	
		return StageTopScore;
	}(PIXI.Container);
	
	exports.default = StageTopScore;
	
	
	StageTopScore.BACKGROUND_COLOR = 0xFFFFFF;
	StageTopScore.TOP_COUNT = 40;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Terrain = function (_PIXI$Container) {
		_inherits(Terrain, _PIXI$Container);
	
		function Terrain() {
			_classCallCheck(this, Terrain);
	
			var _this = _possibleConstructorReturn(this, (Terrain.__proto__ || Object.getPrototypeOf(Terrain)).call(this));
	
			_this.cacheAsBitmap = true;
	
			_this.graphics = new PIXI.Graphics();
			_this.graphics.cacheAsBitmap = true;
			_this.addChild(_this.graphics);
			_this.drawTerrain(new PIXI.Point(-2000, -2000), new PIXI.Point(2000, 2000));
			return _this;
		}
	
		_createClass(Terrain, [{
			key: 'drawTerrain',
			value: function drawTerrain(from, to) {
				this.terrainSize = { from: from, to: to, size: { x: to.x - from.x, y: to.y - from.y } };
				this.graphics.beginFill(0x111111);
				this.graphics.drawRect(from.x, from.y, to.x - from.x, to.y - from.y);
	
				var backgroundImage = new PIXI.Sprite.fromImage(__webpack_require__(4));
				var xs = Math.ceil(this.terrainSize.size.x / backgroundImage.width);
				var ys = Math.ceil(this.terrainSize.size.y / backgroundImage.height);
				for (var x = 0; x < xs; x++) {
					for (var y = 0; y < ys; y++) {
						var s1 = PIXI.Sprite.fromImage(__webpack_require__(4));
						s1.x = this.terrainSize.from.x + x * backgroundImage.width;
						s1.y = this.terrainSize.from.y + y * backgroundImage.height;
						s1.anchor.x = 0.5;
						s1.anchor.y = 0.5;
						if (Math.random() < 0.2) {
							s1.scale.x = -1;
						}
						this.addChild(s1);
						var s2 = PIXI.Sprite.fromImage(__webpack_require__(4));
						s2.x = this.terrainSize.from.x + x * backgroundImage.width + backgroundImage.width / 2;
						s2.y = this.terrainSize.from.y + y * backgroundImage.height + backgroundImage.height / 2;
						s2.anchor.x = 0.5;
						s2.anchor.y = 0.5;
						if (Math.random() < 0.2) {
							s2.scale.x = -1;
						}
						this.addChild(s2);
					}
				}
			}
		}, {
			key: 'randomPoint',
			value: function randomPoint() {
				var x = this.terrainSize.from.x + Math.random() * (this.terrainSize.to.x - this.terrainSize.from.x);
				var y = this.terrainSize.from.y + Math.random() * (this.terrainSize.to.y - this.terrainSize.from.y);
				return new PIXI.Point(x, y);
			}
		}]);
	
		return Terrain;
	}(PIXI.Container);
	
	exports.default = Terrain;
	
	
	Terrain.WATER_HEIGHT = 0.1;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _In = __webpack_require__(6);
	
	var _In2 = _interopRequireDefault(_In);
	
	var _Out = __webpack_require__(39);
	
	var _Out2 = _interopRequireDefault(_Out);
	
	var _Point = __webpack_require__(41);
	
	var _Point2 = _interopRequireDefault(_Point);
	
	var _Reservoir = __webpack_require__(42);
	
	var _Reservoir2 = _interopRequireDefault(_Reservoir);
	
	var _Pipe = __webpack_require__(40);
	
	var _Pipe2 = _interopRequireDefault(_Pipe);
	
	var _Building = __webpack_require__(1);
	
	var _Building2 = _interopRequireDefault(_Building);
	
	var _Structure = __webpack_require__(3);
	
	var _Structure2 = _interopRequireDefault(_Structure);
	
	var _Utils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BuildCursor = function (_PIXI$Container) {
		_inherits(BuildCursor, _PIXI$Container);
	
		function BuildCursor(world, editBuildingGui, interactionManager, stagePlay) {
			_classCallCheck(this, BuildCursor);
	
			var _this = _possibleConstructorReturn(this, (BuildCursor.__proto__ || Object.getPrototypeOf(BuildCursor)).call(this));
	
			_this.world = world;
			_this.editBuildingGui = editBuildingGui;
			_this.interactionManager = interactionManager;
			_this.stagePlay = stagePlay;
	
			_this.building = null;
			_this.buildingPipe = false;
			_this.onChange = function () {};
			_this.mouse_x = 0;
			_this.mouse_y = 0;
	
			_this.buildingPipeGraphics = new PIXI.Graphics();
	
			world.interactive = true;
	
			world.on("mousemove", function (e) {
				_this.mouse_x = e.data.global.x / _this.scale.x;
				_this.mouse_y = e.data.global.y / _this.scale.y;
				if (_this.building !== null) {
					_this.building.x = _this.mouse_x;
					_this.building.y = _this.mouse_y;
				}
				if (_this.buildingPipe !== false) {
					_this.buildingPipeGraphics.clear();
					if (_this.buildingPipe.from !== undefined) {
						var color = 0xffffff;
						if ((0, _Utils.distance)(_this.buildingPipe.from, { x: (_this.mouse_x - _this.world.x) * _this.world.scale.x, y: (_this.mouse_y - _this.world.x) * _this.world.scale.y }) > _Pipe2.default.MAX_PIPE_LENGTH) {
							color = 0xff0000;
						}
						_this.buildingPipeGraphics.lineStyle(2, color).moveTo(_this.buildingPipe.from.x + _this.world.x / _this.world.scale.x, _this.buildingPipe.from.y + _this.world.y / _this.world.scale.y).lineTo(_this.mouse_x, _this.mouse_y);
					}
				}
			});
	
			world.on("mousedown", function (e) {
	
				if (_this.buildingPipe !== false) {
					//Place pipe
	
					var hit = _this.interactionManager.hitTest(e.data.global, _this.world);
					if (hit instanceof _Building2.default) {
	
						if (_this.buildingPipe.from === undefined || _this.buildingPipe.from === hit) {
							_this.buildingPipe.from = hit;
						} else {
	
							//pipe already exists
							var canPlace = true;
							_this.buildingPipe.from.pipes.forEach(function (p) {
								var obs = p.getOther(_this.buildingPipe.from);
								if (obs[0] === hit) {
									canPlace = false;
								}
							});
	
							//too far
							if ((0, _Utils.distance)(_this.buildingPipe.from, hit) > _Pipe2.default.MAX_PIPE_LENGTH) {
								canPlace = false;
							}
	
							if (canPlace) {
								_this.buildingPipe.to = hit;
								world.pipes.addChild(new _Pipe2.default(_this.buildingPipe.from, _this.buildingPipe.to));
								_this.buildingPipe = false;
								_this.removeChild(_this.buildingPipeGraphics);
								_this.onChange(null);
							} else {
	
								editBuildingGui.setBuilding(null);
								_this.buildingPipe = false;
								_this.removeChild(_this.buildingPipeGraphics);
								_this.onChange(null);
							}
						}
					} else {
	
						editBuildingGui.setBuilding(null);
						_this.buildingPipe = false;
						_this.removeChild(_this.buildingPipeGraphics);
						_this.onChange(null);
					}
				} else if (_this.building !== null) {
					//Place building
	
					_this.removeChild(_this.building);
					_this.building.interactive = true;
					_this.building.x = _this.building.x - _this.world.x / _this.world.scale.x;
					_this.building.y = _this.building.y - _this.world.y / _this.world.scale.y;
	
					world.buildings.addChild(_this.building);
					world.buildings.children.sort(function (a, b) {
						return a.y - b.y;
					});
	
					_this.building = null;
					_this.onChange(null);
				} else {
	
					var _hit = _this.interactionManager.hitTest(e.data.global, _this.world);
					if (_hit instanceof _Structure2.default) {
						editBuildingGui.setBuilding(_hit);
					} else {
						editBuildingGui.setBuilding(null);
					}
				}
			});
			return _this;
		}
	
		_createClass(BuildCursor, [{
			key: 'newBuilding',
			value: function newBuilding(type) {
				this.buildingPipe = false;
				if (this.building !== null) {
					this.removeChild(this.building);
				}
				this.building = null;
	
				switch (type) {
					case 'in':
						this.building = new _In2.default();
						this.addChild(this.building);
						this.onChange('in');
						break;
					case 'out':
						this.building = new _Out2.default(this.stagePlay);
						this.addChild(this.building);
						this.onChange('out');
						break;
					case 'point':
						this.building = new _Point2.default();
						this.addChild(this.building);
						this.onChange('point');
						break;
					case 'pipe':
						this.buildingPipe = {
							from: undefined,
							to: undefined
						};
						this.buildingPipeGraphics.clear();
						this.addChild(this.buildingPipeGraphics);
						this.onChange('pipe');
						break;
					case 'reservoir':
						this.building = new _Reservoir2.default();
						this.addChild(this.building);
						this.onChange('reservoir');
						break;
					default:
						throw new Error("Illegal building type");
				}
	
				if (this.building !== null) {
					this.building.x = this.mouse_x;
					this.building.y = this.mouse_y;
				}
			}
		}]);
	
		return BuildCursor;
	}(PIXI.Container);
	
	exports.default = BuildCursor;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _KeyListener = __webpack_require__(5);
	
	var _KeyListener2 = _interopRequireDefault(_KeyListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BuildingsBar = function (_PIXI$Container) {
	  _inherits(BuildingsBar, _PIXI$Container);
	
	  function BuildingsBar(buildCursor) {
	    _classCallCheck(this, BuildingsBar);
	
	    var _this = _possibleConstructorReturn(this, (BuildingsBar.__proto__ || Object.getPrototypeOf(BuildingsBar)).call(this));
	
	    _this.buildCursor = buildCursor;
	
	    _this.buildings = [['in', __webpack_require__(8)], ['out', __webpack_require__(9)], ['point', __webpack_require__(10)], ['pipe', __webpack_require__(47)], ['reservoir', __webpack_require__(11)]].map(function (typeData, index) {
	      var type, image;
	
	      var _typeData = _slicedToArray(typeData, 2);
	
	      type = _typeData[0];
	      image = _typeData[1];
	
	
	      var sprite = new PIXI.Sprite.fromImage(image);
	      sprite.x = 60 * index;
	      sprite.interactive = true;
	      sprite.click = _this.newBuilding.bind(_this, index);
	
	      var spriteText = new PIXI.Text("" + (index + 1), new PIXI.TextStyle({ fontSize: 15, fill: 0x000000 }));
	      spriteText.x = 1;
	      spriteText.y = 1;
	      sprite.addChild(spriteText);
	
	      return {
	        type: type,
	        keyListener: new _KeyListener2.default(49 + index, _this.newBuilding.bind(_this, index)),
	        sprite: sprite
	      };
	    });
	
	    _this.buildings.forEach(function (b) {
	      return _this.addChild(b.sprite);
	    });
	
	    _this.buildCursor.onChange = function (type) {
	      _this.buildings.forEach(function (building) {
	        if (building.type === type) {
	          building.sprite.alpha = 0.5;
	        } else {
	          building.sprite.alpha = 1.0;
	        }
	      });
	    };
	    return _this;
	  }
	
	  _createClass(BuildingsBar, [{
	    key: 'newBuilding',
	    value: function newBuilding(index) {
	      this.buildCursor.newBuilding(this.buildings[index].type);
	    }
	  }, {
	    key: 'destructor',
	    value: function destructor() {
	      this.buildings.forEach(function (b) {
	        return b.keyListener.close();
	      });
	      this.buildings = undefined;
	    }
	  }]);
	
	  return BuildingsBar;
	}(PIXI.Container);
	
	exports.default = BuildingsBar;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Structure = __webpack_require__(3);
	
	var _Structure2 = _interopRequireDefault(_Structure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditBuildingGui = function (_PIXI$Container) {
	  _inherits(EditBuildingGui, _PIXI$Container);
	
	  function EditBuildingGui(world) {
	    _classCallCheck(this, EditBuildingGui);
	
	    var _this = _possibleConstructorReturn(this, (EditBuildingGui.__proto__ || Object.getPrototypeOf(EditBuildingGui)).call(this));
	
	    _this.world = world;
	    _this.building = null;
	
	    if (_Structure2.default.LEVELING_ENABLED) {
	
	      _this.background = new PIXI.Graphics();
	      _this.background.cacheAsBitmap = true;
	      _this.background.drawRect();
	      _this.background.beginFill(0xCCCCCC);
	      _this.background.drawRect(-80, 10, 160, 100);
	      _this.background.drawPolygon([new PIXI.Point(0, 0), new PIXI.Point(5, 10), new PIXI.Point(-5, 10)]);
	      _this.background.endFill();
	      _this.addChild(_this.background);
	
	      _this.textLevel = new PIXI.Text("Level 0");
	      _this.textLevel.y = 8 + 0;
	      _this.textLevel.anchor.x = 0.5;
	      _this.addChild(_this.textLevel);
	
	      _this.textDowngrade = new PIXI.Text("Downgrade");
	      _this.textDowngrade.anchor.x = 0.5;
	      _this.textDowngrade.y = 8 + 32;
	      _this.textDowngrade.interactive = true;
	      _this.textDowngrade.click = function () {
	        _this.building.downgrade();
	        if (_this.building.level > 0) {
	          _this.setBuilding(_this.building);
	        } else {
	          _this.setBuilding(null);
	        }
	      };
	      _this.addChild(_this.textDowngrade);
	
	      _this.textUpgrade = new PIXI.Text("Upgrade");
	      _this.textUpgrade.anchor.x = 0.5;
	      _this.textUpgrade.y = 8 + 64;
	      _this.textUpgrade.interactive = true;
	      _this.textUpgrade.click = function () {
	        _this.building.upgrade();
	        _this.setBuilding(_this.building);
	      };
	      _this.addChild(_this.textUpgrade);
	    } else {
	
	      _this.background = new PIXI.Graphics();
	      _this.background.cacheAsBitmap = true;
	      _this.background.drawRect();
	      _this.background.beginFill(0xCCCCCC);
	      _this.background.drawRect(-80, 10, 160, 46);
	      _this.background.drawPolygon([new PIXI.Point(0, 0), new PIXI.Point(5, 10), new PIXI.Point(-5, 10)]);
	      _this.background.endFill();
	      _this.addChild(_this.background);
	
	      _this.textDestroy = new PIXI.Text("Destroy");
	      _this.textDestroy.anchor.x = 0.5;
	      _this.textDestroy.y = 8;
	      _this.textDestroy.interactive = true;
	      _this.textDestroy.click = function () {
	        _this.building.downgrade();
	        if (_this.building.level > 0) {
	          _this.setBuilding(_this.building);
	        } else {
	          _this.setBuilding(null);
	        }
	      };
	      _this.addChild(_this.textDestroy);
	    }
	
	    _this.visible = false;
	    return _this;
	  }
	
	  _createClass(EditBuildingGui, [{
	    key: "setBuilding",
	    value: function setBuilding(building) {
	      this.building = building;
	      this.visible = false;
	
	      if (this.building !== null) {
	
	        if (_Structure2.default.LEVELING_ENABLED) {
	          this.textLevel.text = "Level " + this.building.level;
	        }
	
	        this.x = this.building.x * this.world.scale.x + this.world.x;
	        this.y = this.building.y * this.world.scale.y + this.world.y;
	        this.visible = true;
	      }
	    }
	  }]);
	
	  return EditBuildingGui;
	}(PIXI.Container);
	
	exports.default = EditBuildingGui;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Building2 = __webpack_require__(1);
	
	var _Building3 = _interopRequireDefault(_Building2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Out = function (_Building) {
	  _inherits(Out, _Building);
	
	  function Out(stagePlay) {
	    _classCallCheck(this, Out);
	
	    var _this = _possibleConstructorReturn(this, (Out.__proto__ || Object.getPrototypeOf(Out)).call(this, [__webpack_require__(13), __webpack_require__(14), __webpack_require__(15)]));
	
	    _this.stagePlay = stagePlay;
	    _this.sprite.scale.x = 0.2;
	    _this.sprite.scale.y = 0.2;
	    return _this;
	  }
	
	  _createClass(Out, [{
	    key: "getCapacity",
	    value: function getCapacity() {
	      return this.level;
	    }
	  }, {
	    key: "tick",
	    value: function tick() {
	      _get(Out.prototype.__proto__ || Object.getPrototypeOf(Out.prototype), "tick", this).call(this);
	      if (this.isActive()) {
	        this.stagePlay.waterDelivered += this.water;
	        this.water = 0;
	      }
	    }
	  }]);
	
	  return Out;
	}(_Building3.default);
	
	exports.default = Out;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Structure2 = __webpack_require__(3);
	
	var _Structure3 = _interopRequireDefault(_Structure2);
	
	var _Building = __webpack_require__(1);
	
	var _Building2 = _interopRequireDefault(_Building);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pipe = function (_Structure) {
		_inherits(Pipe, _Structure);
	
		function Pipe(from, to) {
			_classCallCheck(this, Pipe);
	
			var _this = _possibleConstructorReturn(this, (Pipe.__proto__ || Object.getPrototypeOf(Pipe)).call(this));
	
			if (!from instanceof _Building2.default || !to instanceof _Building2.default) {
				throw new Error("Wrong structure type, pipes can connect only buildings.");
			}
	
			_this.from = from;
			from.pipes.push(_this);
			_this.to = to;
			to.pipes.push(_this);
	
			_this.x = (from.x + to.x) / 2;
			_this.y = (from.y + to.y) / 2;
	
			_this.waterSpeed = 0;
	
			_this.graphics = new PIXI.Graphics();
			_this.redraw();
			_this.addChild(_this.graphics);
			return _this;
		}
	
		_createClass(Pipe, [{
			key: 'getOther',
			value: function getOther(building) {
				if (this.from === building) {
					return [this.to, 1];
				}
				if (this.to === building) {
					return [this.from, -1];
				}
				throw new Error("Illegal building provided");
			}
		}, {
			key: 'getCapacity',
			value: function getCapacity() {
				return this.level;
			}
		}, {
			key: 'redraw',
			value: function redraw() {
				this.graphics.clear();
	
				var color = 0x010000 * Math.floor(255 * (Math.abs(this.waterSpeed) / this.getCapacity()));
				this.graphics.lineStyle(2, color).moveTo(this.from.x - this.x, this.from.y - this.y).lineTo(this.to.x - this.x, this.to.y - this.y);
			}
		}]);
	
		return Pipe;
	}(_Structure3.default);
	
	exports.default = Pipe;
	
	
	Pipe.MAX_PIPE_LENGTH = 200;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Building2 = __webpack_require__(1);
	
	var _Building3 = _interopRequireDefault(_Building2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Point = function (_Building) {
		_inherits(Point, _Building);
	
		function Point() {
			_classCallCheck(this, Point);
	
			var _this = _possibleConstructorReturn(this, (Point.__proto__ || Object.getPrototypeOf(Point)).call(this, __webpack_require__(16)));
	
			_this.sprite.scale.x = 0.1;
			_this.sprite.scale.y = 0.1;
			return _this;
		}
	
		_createClass(Point, [{
			key: "getCapacity",
			value: function getCapacity() {
				return this.level;
			}
		}]);
	
		return Point;
	}(_Building3.default);
	
	exports.default = Point;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Building2 = __webpack_require__(1);
	
	var _Building3 = _interopRequireDefault(_Building2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Reservior = function (_Building) {
		_inherits(Reservior, _Building);
	
		function Reservior() {
			_classCallCheck(this, Reservior);
	
			var _this = _possibleConstructorReturn(this, (Reservior.__proto__ || Object.getPrototypeOf(Reservior)).call(this, [__webpack_require__(17), __webpack_require__(18), __webpack_require__(19), __webpack_require__(20)]));
	
			_this.sprite.scale.x = 0.2;
			_this.sprite.scale.y = 0.2;
			return _this;
		}
	
		_createClass(Reservior, [{
			key: "getCapacity",
			value: function getCapacity() {
				return this.level * 1000;
			}
		}]);
	
		return Reservior;
	}(_Building3.default);
	
	exports.default = Reservior;

/***/ },
/* 43 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(7);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(7);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 46 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAxCAYAAAB3aZEhAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QYOCCImBf9ycQAAAW1JREFUaN7t2r1KA0EUBeAzcRGCEEwRN4RAbLRRE1BjY+JDWFtZ2ZonEEJeQUkpdjbamEYLQbCzCKYJShQWwUK20mmPhdiIP2t049x4D0yz1XzMDtx7GZAkbchmo8ZquUgAYla1XGSzUSNtSJIEbchCzidvzigxj5dHL/u3Ic1OfZMba6vAZAVS89RpYe/wBKaQ83l7dw/pWVkqwQAgSfEYYwwSGKIoRjGKUYxiFKOY/4jxXK2zXvOdutFzEfD2e1SQ5ypC1Ml8hui3JfGkAwaOiRsxEMygELFiPkLE3Z57Uk8hFowLiB9jXEL0jfmr+/CrGJcRkTESEJEw70Fcnn4mohZ5JOH6GPfL30zSHFrbZsUoRjGKUYxiFKMYhzDp8dRQQJYXZjFSr61vlXyD0YkpkYiH6wsE7VOkxpIAbch8NkPbaYl81XS+v818NkPakAkk0wh6XeweHKOyOAdjjJg1PzONdvcKQa8LJNN4Bsn1Kn7q5ntvAAAAAElFTkSuQmCC"

/***/ },
/* 48 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.06201870.js